import {
  call,
  put,
  select,
} from 'redux-saga/effects';

import {
  ACCEPTABLE_REASON_CODES,
  DOC_UPLOAD_BANNER_ERROR_MESSAGES,
  DOC_UPLOAD_ERROR_MESSAGES,
} from '../constants';
import makeSelectMain from '../../../redux/Main/selectors';
import makeSelectMobile from '../../../redux/Mobile/selectors';
import { post } from '../../request';
import { MOBILE_UPLOAD_CONFIRMATION_SCREEN_DICT } from './constants';

export function* uploadDocumentSaga({
  baseUrl,
  navigationHandler,
  uploadDocumentFailure,
  uploadDocumentSuccess,
}, { payload }) {
  const {
    doc2,
    document,
    documentCategory,
    documentName,
    documentSize,
  } = payload;
  const mobileConfirmationScreenName = MOBILE_UPLOAD_CONFIRMATION_SCREEN_DICT[documentCategory];
  const isMobile = yield select(makeSelectMobile('isMobile'));
  try {
    const loanNumber = yield select(makeSelectMain('selectedLoan'));
    const url = `${baseUrl}/docUpload/awsUpload/${loanNumber}`;
    const response = yield call(post, url, {
      document,
      documentCategory,
      documentName,
      documentSize,
    });
    const response2 = doc2 ? yield call(post, url, doc2) : {};
    const { error } = response || {};
    const { error: error2 } = response2 || {};

    let hasError = false;
    if (error) {
      const { reasons } = error;
      const validReasons = reasons.filter(
        (reason) => !ACCEPTABLE_REASON_CODES.includes(reason),
      );
      if (validReasons.length > 0) {
        const validationError = DOC_UPLOAD_ERROR_MESSAGES[validReasons[0]];
        if (validationError) {
          const bannerError = isMobile ? DOC_UPLOAD_BANNER_ERROR_MESSAGES[validReasons[0]] : false;
          yield put(uploadDocumentFailure({ bannerError, isMobile, validationError }));
          hasError = true;
        } else {
          throw new Error();
        }
      }
    }
    if (error2) {
      const { reasons } = error2;
      const validReasons = reasons.filter(
        (reason) => !ACCEPTABLE_REASON_CODES.includes(reason),
      );
      if (validReasons.length > 0) {
        const validationError = DOC_UPLOAD_ERROR_MESSAGES[validReasons[0]];
        if (validationError) {
          const bannerError = isMobile ? DOC_UPLOAD_BANNER_ERROR_MESSAGES[validReasons[0]] : false;
          yield put(uploadDocumentFailure({
            bannerError,
            isMobile,
            isSecondFile: true,
            validationError,
          }));
          hasError = true;
        } else {
          throw new Error();
        }
      }
    }
    if (!hasError) {
      yield put(uploadDocumentSuccess({ isMobile }));
      if (isMobile) {
        yield call(navigationHandler, mobileConfirmationScreenName);
      }
    }
  } catch (error) {
    /**
     * For payloads >10mb, our server responds with 413, 'request entity too large'. The request
     * doesn't even make it to our route handlers. Our frontend 'request' 'checkStatus' util throws
     * the response statusText as the error for any statusCode >=400 (not including 401).
     *
     * Note: The deployed server might respond slightly different, either capitalizing the response
     * status text or saying 'payload' instead of 'request entity'.
     */
    if (typeof error === 'string' && error.toLowerCase().includes('too large')) {
      yield put(uploadDocumentFailure({
        isMobile,
        validationError: DOC_UPLOAD_ERROR_MESSAGES[27000.1002],
      }));
    } else {
      yield put(uploadDocumentFailure({ isMobile }));
      if (isMobile) {
        yield call(navigationHandler, mobileConfirmationScreenName);
      }
    }
  }
}

export default uploadDocumentSaga;
